import { useId } from 'react';
import { Card, CardBody, CardHeader } from '../../../components/ui/Card';
import { SECTION_COPY } from '../../brand/brandCopy';
import { BRAND_SECTION_IDS } from '../../brand/editPages';
import { BrandFieldShell } from '../../brand/fields/BrandFieldShell';
import { GuidelinesTable } from '../../brand/fields/GuidelinesTable';
import { brandFieldDescribedBy } from '../../brand/fields/fieldParts';
import { EditSection } from '../EditSection';
import type { BrandInformationFormState } from './useBrandInformationForm';

/** The add box's name (the table's own column heading, "Guideline", names the rules). */
export const ADD_GUIDELINE_LABEL = 'Add a guideline';

/**
 * Writing guidelines (spec:265), editable on the Edit page for admins (spec:176): one rule per row,
 * each with its remove button, and an add box under the table (the guideline rules: 300 characters,
 * 50 rules, no duplicates). The card's description is the field's hint, so it is not repeated; the
 * list's source tags sit above the table. Read-only for a member.
 */
export function GuidelinesCard({ form, canEdit }: { form: BrandInformationFormState; canEdit: boolean }) {
  const id = useId();
  const copy = SECTION_COPY.writingGuidelines;
  const { sources, aiSuggested } = form.listProvenance('writingGuidelines');
  return (
    <EditSection page="brand" id={BRAND_SECTION_IDS.writingGuidelines}>
      <Card>
        <CardHeader title={copy.title} description={copy.description} />
        <CardBody>
          <BrandFieldShell
            id={id}
            group={!canEdit}
            label={<span className="sr-only">{canEdit ? ADD_GUIDELINE_LABEL : copy.title}</span>}
            sources={sources}
            aiSuggested={aiSuggested}
            readOnly={!canEdit}
          >
            <GuidelinesTable
              id={id}
              items={form.lists.writingGuidelines}
              onChange={(next) => form.setList('writingGuidelines', next)}
              readOnly={!canEdit}
              disabled={form.saving}
              describedBy={brandFieldDescribedBy(id, { sources, aiSuggested })}
            />
          </BrandFieldShell>
        </CardBody>
      </Card>
    </EditSection>
  );
}
